import React, { useState } from 'react';
import { MenuItem } from '@mui/material';

import KogModalSideComponent from '@/main/components/modal/ModalSide';
import ModalEditPart from '@/main/screens/order/viewOrder/components/modalEditPart/modalEditPart';
import { Controls } from '@/main/services/constants/constantsControl';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import { getTranslateByKey, isShowControlByElementId } from '@/main/services/utils';
import { userIsAdmin, userIsBodyshop, userIsBuyer, userIsInsurer, userIsSupplier } from '@/main/services/utilsUser';

import { useThreeDotsPartClaimContext } from '../context';
import OptionEmptySearchClaim from '../optionEmptySearchClaim';

interface IOptionEditPartSearchClaimProps {
  guidProcurementSupplierItem: string;
  guidQuoteProcurement: string;
  cancelationPending: boolean;
  guidCompany: string;
  idStatus: number;
  isStripePayment: boolean;
  loadViewOrder: (guidQuoteProcurement: string | undefined) => Promise<void>
}
function OptionEditPartSearchClaim({
  guidProcurementSupplierItem,
  guidQuoteProcurement,
  cancelationPending,
  guidCompany,
  idStatus,
  isStripePayment,
  loadViewOrder
}: IOptionEditPartSearchClaimProps) {
  const {
    generateIdMenu,
    closeThreeDotsPartClaim
  } = useThreeDotsPartClaimContext();

  const INITIAL_STATE_EDIT_PART = {
    isOpen: false as boolean,
    guidQuoteProcurement: null as string | null,
    guidProcurementSupplierItem: null as string | null
  };
  type InitialStateEditPart = typeof INITIAL_STATE_EDIT_PART;
  const [editPart, setEditPart] = useState<InitialStateEditPart>(INITIAL_STATE_EDIT_PART);
  const showEditButton =
    isShowControlByElementId(Controls.IdEditPrice) &&
    (userIsAdmin() ||
      userIsSupplier() ||
      userIsInsurer() ||
      (userIsBodyshop() && userIsBuyer(guidCompany))) &&
    !isStripePayment &&
    (idStatus === ProcurementStatusEnum.Assigned ||
      idStatus === ProcurementStatusEnum.Transit && !cancelationPending ||
      idStatus === ProcurementStatusEnum.Delivered ||
      idStatus === ProcurementStatusEnum.Received);

  function handleEditPart() {
    setEditPart({
      isOpen: true,
      guidQuoteProcurement,
      guidProcurementSupplierItem
    });
    closeThreeDotsPartClaim()

  }

  if (!showEditButton) return <OptionEmptySearchClaim option='OptionEditPart' />;
  return (
    <>
      <MenuItem
        id={generateIdMenu('edit-part')}
        onClick={handleEditPart}
      >
        {getTranslateByKey('information.edit')}
      </MenuItem>
      <KogModalSideComponent
        shouldRenderOpen
        open={editPart.isOpen}
        title={getTranslateByKey('information.editPart')}
        titleModalReducer="ModalPartEdit"
        closeModal={() => setEditPart(INITIAL_STATE_EDIT_PART)}>
        <ModalEditPart
          editPart={editPart}
          closeModal={() => setEditPart(INITIAL_STATE_EDIT_PART)}
          loadViewOrder={loadViewOrder}
          INITIAL_STATE_EDIT_PART={INITIAL_STATE_EDIT_PART}
        />
      </KogModalSideComponent>
    </>
  )
}

export default OptionEditPartSearchClaim;
